import { AppTileElementIdPrefix, AppTileElementIdPrefixLength, } from '../models/Constants';
import { getFileTypeFromWorkloadId } from '../utilities/getFileTypeFromWorkloadId';
function referralFromWorkloadId(id) {
    return id &&
        id.length &&
        id.lastIndexOf(AppTileElementIdPrefix, AppTileElementIdPrefixLength) ===
            0
        ? id.substring(AppTileElementIdPrefixLength)
        : '';
}
export function populateWorkloadFields(workloads) {
    workloads === null || workloads === void 0 ? void 0 : workloads.forEach(function (workload) {
        workload.id = workload.Id;
        workload.Referral = workload.IsThirdParty
            ? workload.Id
            : referralFromWorkloadId(workload.Id);
        workload.FileType = getFileTypeFromWorkloadId(workload.Id);
        // TODO: resolve the following fields which is Forms only
        // workload.Url = this.getWorkloadCustomUrl(workload.FileType, workload.Url);
    });
}
//# sourceMappingURL=populateWorkloadFields.js.map